module.exports = __webpack_public_path__ + "static/media/ic_template_7.779a3583.png";